import { Link } from 'react-router-dom';
import { Breadcrumbs, Typography } from "@mui/material";
import { createBreadcrumbUrl } from  "../../helpers/helpCenterUtils.js"

const Breadcrumb = ({ label, path }) => (
  path
    ? <Link to={{ pathname: path }}>{label}</Link>
    : <Typography color="text.primary">{label}</Typography>
);

export default function HelpBreadcrumbs({ breadcrumbData = [] }) {
  return (
    <Breadcrumbs aria-label="breadcrumb"
      sx={{
        mb: 2,
        "& .MuiBreadcrumbs-li a": {
          textDecoration: "none",
          "&:hover": {
            textDecoration: "initial",
          }
        },
      }}
    >
      <Breadcrumb label="Helpcenter" path={createBreadcrumbUrl()} />

      {breadcrumbData.map((n, index) => (
        <Breadcrumb
          key={index}
          label={n.title}
          path={index < breadcrumbData.length - 1 ? createBreadcrumbUrl(n) : null}
        />
      ))}
    </Breadcrumbs>
  );
};
